module.exports = __webpack_public_path__ + "img/electronic_use.5113222d.svg";